import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import qs from 'qs';
import { withNamespaces } from 'react-i18next';
import MultipleDropdownSelect from '@mynewsdesk/ui/lib/MultipleDropdownSelect';
import { searchSuggestions } from './actions';
import {
  getSearchQueryString,
  getSearchQueryTopics,
  getPathname,
  getSearchRegionQueryString,
} from 'modules/global/reducers';
import {
  getTopics,
  getTopicsLabelsForIds,
  getRegions,
  getRegionsLabelsForIds,
} from './reducers';
import { getLocale } from 'modules/user/reducers';

import './_styles.scss';

class SearchTool extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      topicListSuggestions: [],
      userIsTypingRegion: false,
    };
  }
  componentDidMount() {
    const { onSearchSuggestions, locale } = this.props;
    onSearchSuggestions(locale);
  }

  componentDidUpdate(prevProps) {
    let { topicListSuggestions } = this.state;
    const { topicsList, searchQueryString } = this.props;
    if (prevProps.topicsList !== this.props.topicsList) {
      this.setState({
        topicListSuggestions: topicsList
          .filter(item => !!item.label)
          .map(item => ({
            label: item.label,
            value: item.label,
            id: item.id,
          })),
      });
    }
    if (prevProps.topicsList !== topicsList && searchQueryString.length) {
      topicListSuggestions = topicsList
        .filter(item => !!item.label)
        .map(item => ({
          label: item.label,
          value: item.label,
          id: item.id,
        }));
      this.queryStringToArray(searchQueryString).forEach(item =>
        topicListSuggestions.unshift({ label: item, value: item, id: item }),
      );
      this.setState({ topicListSuggestions });
    }
  }

  quoteAndTrim = tag => {
    tag = tag.trim();

    if (tag.split(' ').length > 1) {
      return `"${tag}"`;
    } else {
      return tag;
    }
  };

  queryStringToArray = query => {
    /* 
      Splits query string by double quotes first,
      and by whitespace characters second
    */
    return query.split(/"(.*?)"|\s/).filter(n => n);
  };

  onButtonSubmit = e => {
    const {
      searchQueryTopics,
      searchQueryRegions,
      searchQueryString,
    } = this.props;

    const query = {
      q: searchQueryString,
      topics: searchQueryTopics,
      regions: searchQueryRegions,
    };
    e.preventDefault();
    this.submit(query);
  };

  submit = query => {
    const { submit, pathname } = this.props;

    for (let key in query) {
      if (!query[key].length) {
        delete query[key];
      }
    }

    const search = qs.stringify(query, {
      addQueryPrefix: true,
      encodeValuesOnly: true,
    });
    const action = pathname === 'organisations' ? pathname : 'stories';
    submit(action, search);
  };

  onChangeTopics = e => {
    const { searchQueryRegions } = this.props;
    let { topicListSuggestions } = this.state;

    let query = {
      q: '',
      topics: '',
      regions: searchQueryRegions,
    };

    let searchIds = e.target.id;
    let freeTextArr = [];

    e.target.value.forEach((el, i) => {
      if (el === e.target.id[i]) {
        query['q'] = `${query['q']} ${this.quoteAndTrim(el)}`.trim();
        freeTextArr.push(el);
        searchIds = searchIds.filter(n => n !== e.target.id[i]);
      }
    });

    query['topics'] = searchIds.join(' ');

    this.submit(query);

    topicListSuggestions.forEach(el => {
      if (isNaN(parseInt(el.id)) && !freeTextArr.find(n => n === el.id)) {
        topicListSuggestions = topicListSuggestions.filter(n => n !== el);
      }
    });

    this.setState({ topicListSuggestions });
  };

  onChangeRegions = e => {
    const {
      searchQueryTopics,
      searchQueryRegions,
      searchQueryString,
    } = this.props;

    let query = {
      q: searchQueryString,
      topics: searchQueryTopics,
      regions: searchQueryRegions,
    };
    query[e.target.name] = e.target.id.join(' ');

    this.submit(query);
  };

  getDropdownOptions = list => {
    const { userIsTypingRegion } = this.state;
    const { searchQueryRegions } = this.props;

    if (userIsTypingRegion || !!searchQueryRegions) {
      return list.map(item => ({
        label: item.label,
        value: item.label,
        id: item.id,
      }));
    } else {
      return [];
    }
  };

  onRegionInputChange = e => {
    this.setState({ userIsTypingRegion: e.length > 0 });
  };

  onInputChange = e => {
    const { searchQueryString } = this.props;
    let { topicListSuggestions } = this.state;

    const freeTextArr = this.queryStringToArray(searchQueryString);

    const existingTags = topicListSuggestions.find(el => el.label === e);

    if (
      topicListSuggestions.length &&
      topicListSuggestions[0].id === topicListSuggestions[0].label &&
      !freeTextArr.find(el => el === topicListSuggestions[0].label) &&
      e.length
    ) {
      topicListSuggestions.shift();
    }

    if (!existingTags && e.length) {
      topicListSuggestions.unshift({
        label: e,
        value: e,
        id: e,
      });
    }

    this.setState({ topicListSuggestions });
  };

  getTopicValues = () => {
    const { topicLabels, searchQueryString } = this.props;
    const freeTextArr = this.queryStringToArray(searchQueryString);
    const topicsArr = topicLabels.map(label => label.label);
    return freeTextArr.concat(topicsArr);
  };

  getRegionValues = list => list.map(label => label.label);

  render() {
    const {
      t,
      regionLabels,
      regionsList,
      searchQueryString,
      searchQueryTopics,
      searchQueryRegions,
    } = this.props;
    const { topicListSuggestions } = this.state;

    const query = {
      q: searchQueryString,
      topics: searchQueryTopics,
      regions: searchQueryRegions,
    };

    return (
      <form className="mnd-story-search" onSubmit={this.onButtonSubmit}>
        <input type="hidden" name="media" value="" />
        <input type="hidden" name="query" value={query} />
        <div className="mnd-story-search__top-dropdown-wrapper">
          <MultipleDropdownSelect
            className="mnd-story-search__topics-dropdown mnd-story-search__multiple-dropdown-select"
            name="topics"
            options={topicListSuggestions}
            onChange={this.onChangeTopics}
            value={this.getTopicValues()}
            onInputChange={this.onInputChange}
            aria-label={t('search_story-search_dropdown-placeholder-topics')}
            inputProps={{
              placeholder: !!this.getTopicValues().length
                ? ''
                : t('search_story-search_dropdown-placeholder-topics'),
              title: t('search_story-search_dropdown-placeholder-topics'),
            }}
          />
        </div>
        <div className="mnd-story-search__bottom-dropdown-wrapper">
          <MultipleDropdownSelect
            className="mnd-story-search__regions-dropdown mnd-story-search__multiple-dropdown-select"
            name="regions"
            options={this.getDropdownOptions(regionsList)}
            onChange={this.onChangeRegions}
            value={this.getRegionValues(regionLabels)}
            onInputChange={this.onRegionInputChange}
            aria-label={t('search_story-search_dropdown-placeholder-regions')}
            inputProps={{
              placeholder: !!regionLabels.length
                ? ''
                : t('search_story-search_dropdown-placeholder-regions'),
              title: t('search_story-search_dropdown-placeholder-regions'),
            }}
          />
        </div>
        <button
          className="mnd-story-search__action mnd-button mnd-button--submit"
          type="submit"
        >
          {t('common_search')}
        </button>
      </form>
    );
  }
}

export default connect(
  state => ({
    locale: getLocale(state),
    pathname: getPathname(state).replace(/\//, ''),
    searchQueryString: getSearchQueryString(state),
    searchQueryTopics: getSearchQueryTopics(state),
    searchQueryRegions: getSearchRegionQueryString(state),
    topicsList: getTopics(state),
    topicLabels: getTopicsLabelsForIds(state, getSearchQueryTopics(state)),
    regionsList: getRegions(state),
    regionLabels: getRegionsLabelsForIds(
      state,
      getSearchRegionQueryString(state),
    ),
  }),
  dispatch => ({
    onSearchSuggestions: locale => dispatch(searchSuggestions(locale)),
    submit: (pathname, search) => dispatch(push({ pathname, search })),
  }),
)(withNamespaces()(SearchTool));
